import { useInfiniteQuery } from "@tanstack/react-query";
import { MultiOrderItem } from "../types/items";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { FilterValue } from "../../shared/filters/types/filter";

const fetchItemsByRefillArea = async (
  refillAreaId: string,
  pageParam: number,
  filterValues: FilterValue[]
) => {
  const pageSize = 20;

  const getFilterValue = (id: string) =>
    filterValues.find((filter) => filter.filterId === id)?.value;

  const sortBy = getFilterValue("sortBy") ?? "mostRecentlyRefilled";
  const hfb = getFilterValue("hfb");
  const groupBy = getFilterValue("groupBy");

  const params = new URLSearchParams({
    refillAreaId,
    limit: pageSize.toString(),
    page: pageParam.toString(),
    sortBy: sortBy.toString(),
  });

  if (hfb) params.append("homeLocationHfb", hfb.toString());
  if (groupBy) params.append("groupBy", groupBy.toString());

  const callUrl = `${TASKS_SERVICE_URL}/v1/products/refill_area_id?${params}`;

  const response = await fetchAPI("GET", callUrl);
  const data = response?.result?.data;

  if (!!data.articles && !!data.articles.length) {
    const articles = data.articles.map((article: MultiOrderItem) => {
      return {
        ...article,
        selectedPieces: article.lastRefilledQuantity,
      };
    }) as MultiOrderItem[];
    return {
      items: articles,
      pageParam,
      totalPagesCount: data.totalPagesCount || 0,
    };
  }

  return { items: [], pageParam, totalPagesCount: 0 };
};

const useItemsByRefillArea = (
  refillAreaId: string,
  filterValues: FilterValue[]
) => {
  return useInfiniteQuery({
    queryKey: [
      "itemsByRefillArea",
      refillAreaId,
      filterValues.map((filter) => `${filter.filterId} - ${filter.value}`),
    ],
    queryFn: async ({ pageParam }) =>
      fetchItemsByRefillArea(refillAreaId, pageParam, filterValues),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (allPages[0]?.totalPagesCount) {
        return lastPage.pageParam + 1;
      }
      return undefined;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export default useItemsByRefillArea;
